import { combineReducers, type Reducer } from "redux";
import { BEGIN_LOADING_NAVIGATION, LOADING_SUCCESS, type NavigationActions } from "~/features/navigation/redux/actions";
import { type NavigationNode } from "~/domains/navigation/types/NavigationTypes";
import { type CategoryNavigationState } from "~/features/navigation/redux/types";

const isLoading: Reducer<boolean, NavigationActions> = (state = false, action) => {
  switch (action.type) {
    case BEGIN_LOADING_NAVIGATION: {
      return true;
    }
    case LOADING_SUCCESS: {
      return false;
    }

    default:
      return state;
  }
};

const EMPTY_ROOT: NavigationNode = {
  id: -1,
  gaLabel: "",
  title: "",
  level: -1,
  openInNewTab: false,
  children: [],
  usefulTools: [],
  showSeriesTree: false,
};

const INITIAL_CATEGORY_NAVIGATION_STATE: CategoryNavigationState = {
  root: EMPTY_ROOT,
  nodes: {},
};

const categoryNavigation: Reducer<CategoryNavigationState, NavigationActions> = (
  state = INITIAL_CATEGORY_NAVIGATION_STATE,
  action,
) => {
  switch (action.type) {
    case LOADING_SUCCESS: {
      return {
        root: action.payload.root,
        nodes: action.payload.nodes,
      };
    }

    default:
      return state;
  }
};

const flyoutNodes: Reducer<NavigationNode[], NavigationActions> = (state = [], action) => {
  switch (action.type) {
    case LOADING_SUCCESS: {
      return action.payload.flyoutNodes;
    }

    default:
      return state;
  }
};

export const navigationReducer = combineReducers({
  isLoading,
  categoryNavigation,
  flyoutNodes,
});
